<template>
  <div class="container">
    <div class="text">
      <p>Carregando</p>
      <h2>Informações</h2>
        <p>{{progress}}</p>
      <p> Upload {{total}}MB de {{loading}}MB </p>

      <div class="containerLoad">
        <div class="loading"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    progress: Number,
    total: Number,
    loading: Number,
  },
  data() {
    return {
      loadingProgress: 0,
    };
  },
  watch: {
    progress(newValue){
       this.loadingProgress = newValue
    }
  },
};
</script>
<style scoped>
.container {
  position: fixed;
  top: 0;
  left: 0;

  background: rgba(255, 255, 255, 0.548);
  backdrop-filter: blur(5px);
  width: 100%;
  height: 100vh;
  z-index: 9999;

  display: flex;
  justify-content: center;
  align-content: center;
}

.text {
  margin: 0 auto;
  color: #232323;
  width: fit-content;
}
.text p {
  font-size: 1.3rem;
}
.text h2 {
  font-size: 4rem;
}

.containerLoad {
  width: 100%;
  height: 0.4rem;
}
.loading {
  height: 100%;

  animation: loading 2s infinite ease-in-out;
  transform-origin: center;
  transform-box: fill-box;
}
@keyframes loading {
  0% {
    width: 0%;
    margin-left: 0%;
  }
  50% {
    width: 100%;
    margin-left: 0%;
    background: var(--green);
  }
  100% {
    width: 0%;
    margin-left: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .containerLoad {
    top: 3rem;
  }
}
</style>